import { render, staticRenderFns } from "./checkbox-defaultValue-editor.vue?vue&type=template&id=08f9368c&scoped=true&"
import script from "./checkbox-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./checkbox-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9368c",
  null
  
)

export default component.exports